import {useCallback, useContext, useEffect, useState} from "react";
import {Header} from "./MeetingDetails";
import {empType, PageFor} from "../../../../../utils/Enum.types";
import {Title} from "../../../../../stories/Title/Title";
import {AppContext} from "../../../../../context/context";
import {CustomModal, toStandardDate} from "../../../../../utils/UtilFunctions";
import {
  ViewAssetStylesRaiseTicket,
  ViewMoreFileStyles,
} from "../../../../../styles/CustomModalStyles";
import Edit from "../planning/Edit";
import {idAndFlagType} from "../../../../../utils/formTypes";
import {EMPTY_STRING, emptyIdAndModal} from "../../../../../utils/constants";
import {
  GetMomAttCountResult,
  GetMomAttCountVars,
  GetMomDetailsResult,
  GetMomDetailsVars,
} from "../queries/types";
import {useLazyQuery} from "@apollo/client";
import {GetMomAttCount, GetMomDetails} from "../queries/query";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {getDownloadUrl} from "../../../../../utils/DownloadFile";
import Pdf from "../../../../../images/DownloadPdf.svg";
import Image from "../../../../../images/DownloadImage.svg";
import Doc from "../../../../../images/WordDocument.svg";
import Xls from "../../../../../images/Excel.svg";
import {Button} from "../../../../../stories/Button/Button";
import Close from "../../../../../images/Close.svg";
import ViewVendorNotes from "./ViewVendorNotes";
import {CustomDrawer} from "../../../../../styles/CustomDrawerStyles";
import AttendedEmployeesList from "./AttendedEmployeesList";
import MeetingHeader from "../customComponents/MeetingHeader";
import {docTypeEnum} from "./PreviousMeetingDetails";
interface Props {
  pageType: PageFor;
}

const PresentMeetingDetails = ({pageType}: Props) => {
  const {state} = useContext(AppContext);
  const [pmuFilesModal, setPmuFilesModal] = useState(false);
  const [vendorFilesModal, setVendorFilesModal] = useState(false);
  const [attachmentId, setAttachmentId] = useState(0);
  const [pmuResponseFilesModal, setPmuResponseFilesModal] = useState(false);

  const [commentFiles, setPmuFiles] = useState<string[]>([]);
  const [vendorDocs, setVendorDocs] = useState<string[]>([]);
  const [pmuResponseDocs, setPmuResponseDocs] = useState<string[]>([]);

  const [attendanceDetails, setAttendanceDetails] = useState(false);

  const {customer_id, projectID, momID} = useUrlParams();
  const [fillDetails, setFillDetails] =
    useState<idAndFlagType>(emptyIdAndModal);
  const [GetDetails, {data}] = useLazyQuery<
    GetMomDetailsResult,
    GetMomDetailsVars
  >(GetMomDetails);

  const [checkAttMarked, {data: checkAttMarkedStatus, error}] = useLazyQuery<
    GetMomAttCountResult,
    GetMomAttCountVars
  >(GetMomAttCount);
  useEffect(() => {
    if (customer_id && momID && projectID) {
      checkAttMarked({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest: false,
        },
      });
    }
  }, [customer_id, momID, projectID, checkAttMarked]);

  useEffect(() => {
    if (customer_id && momID && projectID) {
      GetDetails({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest: false,
        },
      });
    }
  }, [GetDetails, momID, projectID, customer_id]);

  const downloadFile = (
    ext: string,
    index: number,
    momId: number,
    commentId: number,
    doc: docTypeEnum
  ) => {
    let filename = "";
    switch (doc) {
      case docTypeEnum.COMMENT:
        filename = `${customer_id}/momDetails/${momID}/${projectID}/${commentId}_${index}.${ext}`;
        break;
      case docTypeEnum.VENDOR_RESPONSE:
        filename = `${customer_id}/momDetails/${momID}/${projectID}/vendorResponses/${commentId}_${index}.${ext}`;
        break;
      case docTypeEnum.PMU_RESPONSE:
        filename = `${customer_id}/momDetails/${momID}/${projectID}/pmuResponses/${commentId}_${index}.${ext}`;
        break;
      default:
        break;
    }
    try {
      if (filename) getDownloadUrl(filename, true);
    } catch (err) {
      console.error(err);
    }
  };

  const chooseFile = useCallback(
    (
      file: string,
      index: number,
      momId: number,
      commentId: number,
      doc: docTypeEnum
    ) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({image}: {image: string}) => {
        return (
          <div
            className="meeting-details--left--block--attachments--file"
            onClick={() => downloadFile(ext!, index, momId, commentId, doc)}
          >
            {file} <img src={image} alt="not found" />
          </div>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={Image} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );

  const chooseFileMore = useCallback(
    (
      file: string,
      index: number,
      momId: number,
      commentId: number,
      doc: docTypeEnum
    ) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({image}: {image: string}) => {
        return (
          <>
            <div
              className="meeting-details--left--block--attachments--file"
              onClick={() => downloadFile(ext!, index, momId, commentId, doc)}
            >
              <span> {file}</span> <img src={image} alt="not found" />
            </div>
          </>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={Image} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );

  if (data && data.GetMomDetails)
    return (
      <>
        {pageType === PageFor.GENERAL && (
          <div className="meeting-details--right--header">
            <MeetingHeader fill={false} momId={momID!} latest={false} />
          </div>
        )}

        <div className="meeting-details--right--sub-h">
          {checkAttMarkedStatus ? (
            <div className="meeting-details--right--sub-h--att">
              <div>
                {checkAttMarkedStatus.GetMomAttCount.empCount +
                checkAttMarkedStatus.GetMomAttCount.inviteesCount ? (
                  <b onClick={() => setAttendanceDetails(!attendanceDetails)}>
                    {checkAttMarkedStatus
                      ? Number(checkAttMarkedStatus.GetMomAttCount.empCount) +
                        Number(
                          checkAttMarkedStatus.GetMomAttCount.inviteesCount
                        )
                      : 0}
                    Members
                  </b>
                ) : (
                  <b onClick={() => setAttendanceDetails(!attendanceDetails)}>
                    {checkAttMarkedStatus
                      ? Number(checkAttMarkedStatus.GetMomAttCount.empCount) +
                        Number(
                          checkAttMarkedStatus.GetMomAttCount.inviteesCount
                        )
                      : 0}
                    Members
                  </b>
                )}
              </div>
              <span className="font-green">Present</span>
            </div>
          ) : (
            <span className="font-red">Un Marked</span>
          )}
          {pageType === PageFor.MODAL && <Title>History</Title>}
          <div className="overall-total-count">
            Total Points : {data && <b>{data.GetMomDetails.length}</b>}
          </div>
        </div>
        <div className="meeting-details--left--block">
          <div
            className={`meeting-details--left--block--header${
              state.empSubType === empType.VENDOR_MANAGER ? "--vendor" : ""
            }`}
          >
            {Header.map((res, index) => {
              return (
                <div
                  className="meeting-details--left--block--header--li"
                  key={index}
                >
                  {res}
                </div>
              );
            })}
          </div>
          <div className="meeting-details--left--block--sub">
            {data &&
              data.GetMomDetails.map((res, index) => {
                let pmuFiles: string[] = [];
                let pmuVisibleFiles: string[] = [];
                let pmuRemainingCount = 0;

                if (res.pmuComments.trim() !== EMPTY_STRING) {
                  pmuFiles = res.pmuDocuments.split(";");
                  pmuVisibleFiles = pmuFiles.slice(0, 2);
                  pmuRemainingCount = pmuFiles.length - 2;
                }
                let vendorFiles: string[] = [];
                let vendorVisibleFiles: string[] = [];
                let vendorRemainingCount = 0;

                if (res.vendorDocuments.trim() !== EMPTY_STRING) {
                  vendorFiles = res.vendorDocuments.split(";") || [];
                  vendorVisibleFiles = vendorFiles.slice(0, 2);
                  vendorRemainingCount = vendorFiles.length - 2;
                }

                let pmuResponseFiles: string[] = [];
                let pmuResponseVisibleFiles: string[] = [];
                let pmuResponseRemainingCount = 0;

                if (res.pmuResponseDocuments.trim() !== EMPTY_STRING) {
                  pmuResponseFiles = res.pmuResponseDocuments.split(";") || [];
                  pmuResponseVisibleFiles = pmuResponseFiles.slice(0, 2);
                  pmuResponseRemainingCount = pmuResponseFiles.length - 2;
                }

                return (
                  <div
                    className={`meeting-details--left--block--list`}
                    key={index}
                  >
                    <span className="meeting-details--left--block--slno">
                      {index + 1}
                    </span>

                    <div className="meeting-details--left--block--attachments">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: res.pmuComments,
                        }}
                      />
                      <div>
                        {pmuVisibleFiles.map((file, i) => {
                          const filename = file.split("/").pop();
                          return (
                            <div key={i}>
                              {chooseFile(
                                filename!,
                                i,
                                res.momID,
                                res.id,
                                docTypeEnum.COMMENT
                              )}
                            </div>
                          );
                        })}

                        {pmuRemainingCount > 0 && (
                          <button
                            onClick={() => {
                              setAttachmentId(res.id);
                              setPmuFiles(res.pmuDocuments.split(";"));
                              setPmuFilesModal(!pmuFilesModal);
                            }}
                          >
                            +{pmuRemainingCount} more
                          </button>
                        )}
                      </div>

                      <CustomModal
                        style={ViewMoreFileStyles}
                        isOpen={pmuFilesModal}
                        onRequestClose={() => setPmuFilesModal(false)}
                        contentComponent={
                          <div className="meeting-details--left--block--more-files">
                            <div className="meeting-details--left--block--more-files-t">
                              <Title>Uploaded Files</Title>
                              <img
                                src={Close}
                                alt=""
                                onClick={() => setPmuFilesModal(!pmuFilesModal)}
                              />
                            </div>
                            <div className="meeting-details--left--block--more-files--block">
                              <ul>
                                {commentFiles.map((files, index) => {
                                  const filename = files.split("/").pop();

                                  return (
                                    <li key={index}>
                                      {chooseFileMore(
                                        filename!,
                                        index,
                                        res.momID,
                                        attachmentId,
                                        docTypeEnum.COMMENT
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                            <Button
                              mode="cancel"
                              onClick={() => setPmuFilesModal(!pmuFilesModal)}
                            />
                          </div>
                        }
                      />
                    </div>

                    {/* <div
                      className="meeting-details--left--block--attachments"
                      
                    >
                      <span dangerouslySetInnerHTML={{ __html: res.pmuComments }}/>
                      {res.pmuDocuments.split(";").map((file, index) => {
                        const filename = file.split("/").pop();
                        return (
                          <>
                            {chooseFile(filename!, index, res.id, empType.PMU)}
                            {filename}
                          </>
                        );
                      })}
                    </div> */}
                    {/* <div>
                      {res.vendorResponse}
                      <div
                        className="meeting-details--left--block--attachments"
                       
                      >
                        <span  dangerouslySetInnerHTML={{ __html: res.vendorDocuments }}/>
                        {res.vendorDocuments.split(";").map((file, index) => {
                          const filename = file.split("/").pop();
                          return (
                            <>
                              {chooseFile(
                                filename!,
                                index,
                                res.id,
                                empType.VENDOR_MANAGER
                              )}
                              {filename}
                            </>
                          );
                        })}
                      </div>
                    </div> */}
                    <div className="meeting-details--left--block--attachments">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: res.vendorResponse,
                        }}
                      />
                      <div>
                        {vendorVisibleFiles.map((file, i) => {
                          const filename = file.split("/").pop();
                          return (
                            <div key={i}>
                              {chooseFile(
                                filename!,
                                i,
                                res.momID,
                                res.id,
                                docTypeEnum.VENDOR_RESPONSE
                              )}
                            </div>
                          );
                        })}

                        {vendorRemainingCount > 0 && (
                          <button
                            onClick={() => {
                              setAttachmentId(res.id);
                              setVendorDocs(res.vendorDocuments.split(";"));
                              setVendorFilesModal(!vendorFilesModal);
                            }}
                          >
                            +{vendorRemainingCount} more
                          </button>
                        )}
                      </div>

                      <CustomModal
                        style={ViewMoreFileStyles}
                        isOpen={vendorFilesModal}
                        onRequestClose={() =>
                          setVendorFilesModal(!vendorFilesModal)
                        }
                        contentComponent={
                          <>
                            <div className="meeting-details--left--block--more-files">
                              <div className="meeting-details--left--block--more-files-t">
                                <Title>Uploaded Files</Title>
                                <img
                                  src={Close}
                                  alt=""
                                  onClick={() =>
                                    setVendorFilesModal(!vendorFilesModal)
                                  }
                                />
                              </div>
                              <div className="meeting-details--left--block--more-files--block">
                                <ul>
                                  {vendorDocs.map((files, index) => {
                                    const filename = files.split("/").pop();
                                    return (
                                      <li key={index}>
                                        {chooseFile(
                                          filename!,
                                          index,
                                          res.momID,
                                          res.id,
                                          docTypeEnum.VENDOR_RESPONSE
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                              <Button
                                mode="cancel"
                                onClick={() =>
                                  setVendorFilesModal(!vendorFilesModal)
                                }
                              />
                            </div>
                          </>
                        }
                      />
                    </div>
                    <div className="meeting-details--left--block--attachments">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: res.pmuResponse,
                        }}
                      />
                      <div>
                        {pmuResponseVisibleFiles.map((file, i) => {
                          const filename = file.split("/").pop();
                          return (
                            <div key={i}>
                              {chooseFile(
                                filename!,
                                i,
                                res.momID,
                                res.id,
                                docTypeEnum.PMU_RESPONSE
                              )}
                            </div>
                          );
                        })}

                        {pmuResponseRemainingCount > 0 && (
                          <button
                            onClick={() => {
                              setAttachmentId(res.id);
                              setPmuResponseDocs(
                                res.pmuResponseDocuments.split(";")
                              );
                              setPmuResponseFilesModal(!pmuResponseFilesModal);
                            }}
                          >
                            +{pmuResponseRemainingCount} more
                          </button>
                        )}
                      </div>

                      <CustomModal
                        style={ViewMoreFileStyles}
                        isOpen={pmuResponseFilesModal}
                        onRequestClose={() =>
                          setPmuResponseFilesModal(!pmuResponseFilesModal)
                        }
                        contentComponent={
                          <>
                            <div className="meeting-details--left--block--more-files">
                              <div className="meeting-details--left--block--more-files-t">
                                <Title>Uploaded Files</Title>
                                <img
                                  src={Close}
                                  alt=""
                                  onClick={() =>
                                    setPmuResponseFilesModal(
                                      !pmuResponseFilesModal
                                    )
                                  }
                                />
                              </div>
                              <div className="meeting-details--left--block--more-files--block">
                                <ul>
                                  {pmuResponseDocs.map((files, index) => {
                                    const filename = files.split("/").pop();
                                    return (
                                      <li key={index}>
                                        {chooseFile(
                                          filename!,
                                          index,
                                          res.momID,
                                          res.id,
                                          docTypeEnum.PMU_RESPONSE
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                              <Button
                                mode="cancel"
                                onClick={() =>
                                  setPmuResponseFilesModal(
                                    !pmuResponseFilesModal
                                  )
                                }
                              />
                            </div>
                          </>
                        }
                      />
                    </div>
                  </div>
                );
              })}{" "}
            <ViewVendorNotes momID={momID!} latest={false} />
          </div>
        </div>
        <CustomModal
          style={ViewAssetStylesRaiseTicket}
          isOpen={fillDetails.flag}
          onRequestClose={() => setFillDetails(emptyIdAndModal)}
          contentComponent={
            <Edit
              setModalFlag={setFillDetails}
              idModalFlag={fillDetails}
              fieldType={docTypeEnum.COMMENT}
            />
          }
        />
        <CustomDrawer
          anchor="right"
          open={attendanceDetails}
          onClose={() => setAttendanceDetails(!attendanceDetails)}
        >
          <AttendedEmployeesList
            setModalFlag={setAttendanceDetails}
            momId={momID!}
            latest={false}
          />
        </CustomDrawer>
      </>
    );

  return <b className="nodata">No Meeting details available</b>;
};

export default PresentMeetingDetails;
